import * as React from 'react'

const SvgVoleyballIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3781_91915)">
      <path
        d="M10.0029 0.0135498C4.48011 0.0135498 0.00292969 4.49072 0.00292969 10.0135C0.00292969 15.5363 4.48011 20.0135 10.0029 20.0135C15.5258 20.0135 20.0029 15.5363 20.0029 10.0135C20.0029 4.49072 15.5258 0.0135498 10.0029 0.0135498ZM18.2167 8.75185V8.75435C17.4619 9.22432 16.6365 9.57015 15.7722 9.77858C15.5929 7.11345 14.712 4.54318 13.2186 2.32844C15.8878 3.45529 17.7804 5.88754 18.2167 8.75185ZM10.0002 1.67949C10.2107 1.67949 10.4163 1.69528 10.6234 1.71112C12.6993 3.99055 13.9325 6.91173 14.118 9.98912C12.981 10.028 11.8481 9.8326 10.7899 9.415C10.6242 6.60155 9.28028 3.98825 7.08808 2.21697C8.01844 1.86373 9.00504 1.68163 10.0002 1.67949ZM5.41313 3.06484C6.19477 3.57456 6.88523 4.21189 7.45579 4.95024C4.96175 6.62269 3.01948 8.99698 1.87445 11.773C1.13376 8.41729 2.54166 4.9527 5.41313 3.06484ZM2.80801 14.1643C3.6386 10.9872 5.59636 8.22068 8.31618 6.38052C8.80866 7.39236 9.08979 8.49393 9.1424 9.61801C6.87169 11.3435 5.4446 13.9556 5.21929 16.7986C4.23534 16.1042 3.41282 15.2057 2.80801 14.1643ZM10.0002 18.3204C8.92376 18.32 7.85767 18.1098 6.86175 17.7013C6.84342 16.628 7.03328 15.5614 7.42088 14.5604C10.1558 15.7744 13.1929 16.1365 16.1366 15.5996C14.5662 17.3311 12.3378 18.3192 10.0002 18.3204ZM8.16973 13.0702C8.69715 12.2527 9.36436 11.5345 10.1409 10.9485C11.317 11.424 12.5732 11.6706 13.8418 11.6748C15.3853 11.6747 16.908 11.3188 18.2916 10.6348C18.2137 11.6517 17.9476 12.6454 17.507 13.5652C14.4347 14.5155 11.1243 14.34 8.16973 13.0702Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3781_91915">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgVoleyballIcon
